import { URI } from '@fiverr-private/futile';
import { HTTP, HTTPS, FIVERR_DOMAIN } from '../../common/uri/constants';

/**
 * Valid External Url
 * @desc validates that url is with http/https protocol and that it's domain is not fiverr.com,
 * this function should only be used in the client side
 * @param {string} url the url to analyze
 * @return {boolean} true if the url is with http/https protocol and external to fiverr, false otherwise
 * **/

export const isValidExternalHttpUrl = (url) => {
    const parsedUrl = new URI(url);

    // this is done in order to exclude invalid urls i.e "gig.page"
    if (parsedUrl.protocol !== HTTP && parsedUrl.protocol !== HTTPS) {
        return false;
    }

    return parsedUrl.top !== FIVERR_DOMAIN;
};
